
import { defineComponent, toRefs } from 'vue';
import { NButton, NInput, NBaseBar } from '@/uikit';

export default defineComponent({
  name: 'SettingsBar',
  components: { NBaseBar, NButton, NInput },
  props: {
    totalCount: { type: [Number, String] },
    searchQuery: { type: String, default: '' },
    createLabelI18N: { type: String, required: false },
    hasCreate: { type: Boolean, default: true }
  },
  emits: ['search', 'create'],
  setup(props, { emit }) {
    return {
      ...toRefs(props),
      emit
    };
  }
});
